export default "__VITE_ASSET__Dfj$7MKz__"